// Interfaces
import {ModelDTO} from './ModelDTO'

interface MergeObject {
    [property: string]: any
}

export abstract class Model<T extends ModelDTO> {

    protected init(initial: Partial<T> = {}) {
        Object.assign(this, JSON.parse(JSON.stringify(initial)))
    }
}





